<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header">
        <h4 class="title">Fleet drivers</h4>
      </div>
      <div class="card-body row">

        <active-filter-list :activeFilters="activeFilters" :tableName="tableName" @remove-filter="removeFilter"
          @clear-filters="clearFilters"></active-filter-list>

        <v-server-table :name="tableName" url="/v1/submerchants" :columns="columns" :options="options" :ref="tableName"
          @filter="addToActiveFilters" @select="updateSelectedRows">
          <template slot="id" slot-scope="props">
            <code>{{ props.row.id }}</code>
          </template>

          <template slot="reference" slot-scope="props">
            <code>{{ props.row.reference }}</code>
          </template>

          <template slot="createdAt" slot-scope="props">
            <div>{{ props.row.createdAt | moment('YYYY-MM-DD HH:mm A') }}</div>
          </template>

          <template slot="updatedAt" slot-scope="props">
            <div>{{ props.row.updatedAt | moment('YYYY-MM-DD HH:mm A') }}</div>
          </template>

          <template slot="isActive" slot-scope="props">
            <span v-if="props.row.isActive">Active</span>
            <span v-else-if="!props.row.isActive">Inactive</span>
          </template>

          <template slot="links" slot-scope="props">
            <router-link :to="`/drivers/${props.row.id}`" class="btn btn-default btn-sm">
              View &nbsp;
              <i class="fa fa-chevron-right"></i>
            </router-link>
          </template>
        </v-server-table>
      </div>
      <div class="card-footer">
        <button class="btn btn-default" @click="openDownloadConfirm" title="Bulk actions"
          :disabled="bulkActionsModalIsOpen">
          <i class="fa fa-bolt mr-2"></i> Download Emergency Kits
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { eachLimit } from "async-es";
import swal from "sweetalert2";

import pdfUtil from "@optimuspay/emergency-kit-utility";
import file from "@optimuspay/emergency-kit-utility/static/files/emergency-kit-template.pdf";
import font1 from "@optimuspay/emergency-kit-utility/static/fonts/HKGrotesk-ExtraBold.otf";
import font2 from "@optimuspay/emergency-kit-utility/static/fonts/HKGrotesk-Regular.otf";

import { requestAdapter } from "../../../../helpers/tableHelpers";
import ActiveFilterList from "src/components/UIComponents/ActiveFilterList.vue";

const columns = [
  "id",
  "reference",
  "name",
  "phoneNumber",
  "emailAddress",
  "postcode",
  "isActive",
  "links"
];

export default {
  name: "SubmerchantsList",
  components: {
    ActiveFilterList
  },
  data() {
    return {
      columns,
      tableName: "submerchantsList",
      activeFilters: [],
      // bulk actions
      bulkActionsModalIsOpen: false,
      bulkActionError: null,
      selectedRows: [],
      bulkAction: "cancel",
      options: {
        name: this.tableName,
        pagination: { chunk: 3 },
        requestAdapter,
        columnsDropdown: false,
        headings: {
          id: "Driver ID",
          reference: "Reference",
          name: "Name",
          phoneNumber: "Phone number",
          emailAddress: "Email address",
          postcode: "Postcode",
          isActive: "Active"
        },
        sortable: _.initial(columns),
        filterable: _.initial(columns),
        selectable: {
          mode: "multiple", // or 'single'
          only: function (row) {
            return true; // you can put conditions based on row contents here
          },
          selectAllMode: "all", // or 'page',
          programmatic: false,
        },
        listColumns: {
          isActive: [
            {
              id: "true",
              text: "Active"
            },
            {
              id: "false",
              text: "Inactive"
            }
          ]
        }
      }
    };
  },
  methods: {
    clearFilters() {
      this.$refs[this.tableName].resetQuery();
      this.$refs[this.tableName].resetCustomFilters();
      this.activeFilters = [];

    },
    containsObject(obj, list) {
      for (const i in list) {
        if (obj.name === list[i].name) {
          return true;
        }
      }
      return false;
    },
    removeFilter(filter) {
      if (filter.name === 'date') {
        filter.name = 'capturedAt';
        Event.$emit(`vue-tables.${this.tableName}.filter::${filter.name}`, "");
      } else {
        const filterObj = {}
        filterObj[filter.name] = '';
        this.$refs[this.tableName].setFilter(filterObj);
      }
    },
    addToActiveFilters(filter) {
      let isDuplicate = this.containsObject(filter, this.activeFilters)

      if (filter.value !== '' && !isDuplicate) {
        this.activeFilters.push(filter)
      } else if (filter.value === '') {
        const index = this.activeFilters.indexOf(filter)
        this.activeFilters.splice(index, 1)
      }
    },
    loadActiveFilters() {
      const tableData = this.$refs[this.tableName].getRequestParams();
      const activeQueries = tableData['query']
      for (let query in activeQueries) {
        if (activeQueries[query] !== '') {
          const queryObj = { name: query, value: activeQueries[query] };
          this.activeFilters.push(queryObj);
        }
      }
    },
    openDownloadConfirm() {
      if (!this.selectedRows.length) {
        swal({
          icon: "error",
          title: "No rows selected",
          text: `Please select at least one row.`,
        });
      } else {
        this.bulkActionsModalIsOpen = true;
        // sweetalert confirm 'are you sure you want to download X files' dialogue
        swal({
          title: "Download Emergency Kits",
          text: `Are you sure you want to download ${this.selectedRows.length} emergency ${this.selectedRows.length === 1 ? 'kit' : 'kits'}?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
        }).then((result) => {
          if (result.value) {
            this.bulkAction = "download";
            this.runBulkAction();
          } else {
            this.bulkActionsModalIsOpen = false;
          }
        });
      }
    },
    refreshTable() {
      this.$refs[this.tableName].refresh();
    },
    updateSelectedRows(rows) {
      this.selectedRows = rows;
    },
    closeBulkActionsModal() {
      // reset state
      this.$refs[this.tableName].resetSelectedRows();
      this.selectedRows = [];
      this.bulkActionError = null;
      this.bulkActionsModalIsOpen = false;
    },
    runBulkAction() {
      const instance = this;

      // run the action and set the results
      const PARALLEL_LIMIT = 10;
      eachLimit(
        this.selectedRows,
        PARALLEL_LIMIT,
        (item, next) => {
          item.working = true;

          if (instance.bulkAction === "cancel") {
            item.working = false;
            item.success = true;
            return next(null);
          } else if (instance.bulkAction === "download") {
            pdfUtil.generate(item, { template: file, fontHeader: font1, fontBody: font2 })
              .then((pdf) => {
                let filename = `${item.id}-${item.name}`;
                if(item.reference) filename += `-${item.reference}`;
                filename += "-emergency-kit.pdf";
                filename = filename.replace(/[^a-zA-Z0-9-.]/g, "_");
                pdfUtil.download(pdf, filename);
                item.working = false;
                item.success = true;
                next(null);
              })
              .catch((err) => {
                console.error(err);
                item.working = false;
                item.error = err.message;
                next(null);
              });
          }
        },
        (err) => {
          if (err) {
            instance.bulkActionError = err.message;
          } else {
            instance.$notify({
              message: "Bulk action completed",
              timeout: 3000,
              icon: "fa fa-check",
              horizontalAlign: "left",
              verticalAlign: "top",
              type: "success",
            });
          }
          this.closeBulkActionsModal();
        }
      )
    },
  },
  mounted() {
    this.loadActiveFilters();
  }
};
</script>
